<template>
<v-container>
  <v-layout align-center justify-center fill-height>
    <v-flex xs12 sm8 md6 lg5 xl4>
      <v-card>
        <v-card-title>
          <logo height="100" style="margin: auto"></logo>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-layout justify-space-between wrap>
              <v-flex xs6>
                <v-select
                    v-if="!form.customHost"
                    :items="hosts"
                    label="Server"
                    v-model="form.host"
                    :rules="[rules.required]"
                ></v-select>
                <v-text-field label="Server" placeholder="IP oder Domain" v-model="form.host"
                              v-if="form.customHost"
                              :rules="[rules.required]"></v-text-field>
              </v-flex>
              <v-checkbox v-model="form.customHost" label="Eigen" style="">
                <template #append>
                  <v-tooltip bottom>
                    <template #activator="{on}">
                      <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>Wenn dieses Feld aktiviert ist, dann kannst du dich zu deinem eigenen TeamSpeak Server verbinden.</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
              <v-flex xs3>
                <v-text-field label="Port" type="number" v-model="form.queryport" :rules="[rules.required]" :disabled="!form.customHost"></v-text-field>
              </v-flex>
                <v-checkbox v-model="form.ssh" label="SSH" style="display: none">
                  <template #append>
                    <v-tooltip bottom>
                      <template #activator="{on}">
                        <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                      </template>
                      <span>If SSH is checked (default), the connection to the
                        ServerQuery is encrypted.</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
              <v-flex xs12>
                <v-text-field label="Name" v-model="form.username" :rules="[rules.required]" placeholder="z.B. serveradmin" name="username" autocomplete="username"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Passwort" type="password" v-model="form.password" :rules="[rules.required]" name="password" autocomplete="current-password"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox label="Eingeloggt bleiben" v-model="rememberLogin"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" :disabled="!valid" @click="connect" :loading="loading">
            <v-icon>arrow_forward</v-icon>Verbinden
            <template #loader>
              <span>Verbinde...</span>
            </template>
          </v-btn>
        </v-card-actions>
        <span :style="{ color: '#BDBDBD', marginLeft: '5px' }">Version {{ appVersion }}</span>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { version } from "../../package.json";
import ChannelEdit from "@/components/ChannelEdit";
import Logo from "@/components/Logo"

export default {
  components: {ChannelEdit, Logo},
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      let token = vm.$store.state.query.token

      vm.$store.commit("isLoggedOut", true)

      if (!token) return;

      vm.$socket.emit("autofillform", token, response => {
          if(response.host) {
            vm.form.host = response.host;
            vm.form.queryport = response.queryport;
            vm.form.ssh = response.protocol === "ssh" ? true : false;
            vm.form.username = response.username;
            vm.form.password = response.password;
          } else {
            vm.$store.dispatch("removeToken")

            vm.$toast.error(response)
          }
        }
      );
    });
  },
  data() {
    return {
      panel: [true],
      valid: false,
      loading: false,
      rules: {
        required: value => !!value || "Required."
      },
      form: {
        host: "",
        queryport: 10011,
        ssh: false,
        username: "",
        password: "",
        customHost: false
      },
      appVersion: version,
      hosts: [
          "s01.ts3clan.de",
          "s02.ts3clan.de",
          "s03.ts3clan.de",
          "s04.ts3clan.de",
          "s05.ts3clan.de",
          "s06.ts3clan.de",
          "s07.ts3clan.de",
          "s08.ts3clan.de",
          "s09.ts3clan.de",
          "s10.ts3clan.de"
      ]
    };
  },
  computed: {
    rememberLogin: {
      set(value) {
        this.$store.commit("setRememberLogin", value)
      },
      get() {
        return this.$store.state.settings.rememberLogin
      }
    }
  },
  methods: {
    connectTeamSpeak(credentials) {
      return this.$TeamSpeak.connect(credentials)
    },
    async connect() {
      this.loading = true

      try {
        let {token} = await this.connectTeamSpeak({
          host: this.form.host,
          queryport: this.form.queryport,
          protocol: this.form.ssh ? "ssh" : "raw",
          username: this.form.username,
          password: this.form.password
        })
        let whoami = await this.$TeamSpeak.execute('whoami').then(list => list[0]);
        await this.$TeamSpeak.selectServer(whoami.client_origin_server_id)

        this.$store.dispatch("saveToken", token)
        this.$store.commit("isConnected", true)
        this.$store.commit("isLoggedOut", false)


        this.$router.push({name: "serverviewer"})
      } catch(err) {

        this.$toast.error(err.message)
      }

      this.loading = false
    }
  },
  watch: {
    "form.ssh"(ssh) {
      ssh ? this.form.queryport = 10022 : this.form.queryport = 10011
    }
  }
};
</script>

<style>
  .v-expansion-panel__header {
    padding: 0 !important;
  }
</style>
